"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propsMain = _interopRequireDefault(require("./props-main"));
var _handleDatas = _interopRequireDefault(require("./handle-datas"));
var _treeMethods = _interopRequireDefault(require("./tree-methods"));
// import propsTableMain from '@/components/wl-table-main/mixins/props-main'
// import propsDrawerSearch from '@/components/wl-drawer-search/mixins/props-main'
// import propsDrawerSearch from '@/components/wl-drawer-search/mixins/props-main'
var _default = exports.default = [_treeMethods.default, _handleDatas.default, _propsMain.default];